import React from "react";
import { Chip, Stack, Tooltip, IconButton, CircularProgress } from "@mui/material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import WifiIcon from "@mui/icons-material/Wifi";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useOrderWsStatusWS } from "../../hooks/useOrderWsStatus";

function fmt(ts) {
    if (!ts) return "—";
    const d = new Date(ts);
    return d.toLocaleString();
}

export default function OrderWsStatusChip({ connectorId }) {
    const { status, reconnect } = useOrderWsStatusWS(connectorId)

    const healthy = !!status?.healthy;
    const connected = !!status?.connected;
    const running = !!status?.is_running;

    let label = "Stopped";
    let icon = <WifiOffIcon fontSize="small" />;
    let color = "default";
    if (running && connected && healthy) { label = "Connected"; icon = <WifiIcon fontSize="small" />; color = "success"; }
    else if (running && !connected) { label = "Reconnecting"; icon = <PendingIcon fontSize="small" />; color = "warning"; }
    else if (running && connected && !healthy) { label = "Degraded"; icon = <ErrorOutlineIcon fontSize="small" />; color = "warning"; }


    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <Tooltip title={status?.last_error || ""}>
                <Chip size="small" label={label} color={color} icon={icon} />
            </Tooltip>
            {!healthy && (
                <IconButton size="small" onClick={reconnect} aria-label="reconnect">
                    <RestartAltIcon fontSize="small" />
                </IconButton>
            )}
        </Stack>
    );
}
